module.exports = __webpack_public_path__ + "static/img/btn1.98c6891.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/5/btn1.png
// module id = sIKd
// module chunks = 0